import { apiGetConfirmEmail } from '@/modules/Claim/services/pdf'
import flowMixin from '@/modules/Flow/mixins/flowMixin'
import { FLOW_TRANSITIONS } from '@/modules/Flow/constants'
import maActionsButtons from '@/components/button-blue'

export default {
  name: 'claimClosing',

  mixins: [flowMixin],

  components: {
    maActionsButtons
  },

  methods: {
    sendConfirmEmail() {
      apiGetConfirmEmail({ sinisterId: this.getSinisterId })
    },

    trackFlowEnd() {
      const endTrackMessage = `Selfcare - customer journey completed`
      this.trackUserFlowTimeStamp(endTrackMessage, this.getSinisterId)
    },

    handlePrimaryButtonClick() {
      this.goToNextState(FLOW_TRANSITIONS.SHOW_MOBILIER)
    },

    handleGoToTheURL(){
      window.location.href = "https://particuliers.sg.fr/com/icd-web/cbo/index.html";
    }
  },

  mounted() {}
}
